import React, { Component } from 'react';

import Create from './Create';
import View from './View';

class FormContainer extends Component {
	render() {
		let { formType, selectedData, stateSetter, loadOptions } = this.props;

		let createProps = {
			formType,
			selectedData,
			stateSetter,
			loadOptions,
		};

		switch (formType.toUpperCase()) {
			case 'CREATE':
				return <Create {...createProps} />;
				break;
			case 'VIEW':
				return <View selectedData={selectedData} />;
				break;
			case 'UPDATE':
				return <Create {...createProps} />;
				break;
			case 'DELETE':
				return (
					<h5>
						ARE YOU SURE YOU WANT TO DELETE{' '}
						<span style={{ color: 'red' }}>
							{selectedData || selectedData !== ''
								? typeof selectedData.get('username') !== 'undefined'
									? selectedData.get('username')
									: ''
								: ''}
						</span>
						?
					</h5>
				);
				break;
			default:
				return <h1></h1>;
		}
	}

	componentWillUnmount() {
		let { stateSetter, selectedData } = this.props;

		if (typeof selectedData !== 'undefined' && selectedData !== null) {
			stateSetter([{ state: 'selectedData', value: selectedData.revert() }]);
		}
	}
}

export default FormContainer;



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/index.js